import React, { useState, useEffect } from "react";
import {
    Alert,
    Col,
    Form,
    Row,
    Spinner, 
    Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

import {
    getFormacionColaborador,
    saveFormacionColaborador,
    editFormacionColaborador,
    clearFormacionColaborador
} from "../../redux/Carrera_Sucesion/PerfilColaborador/actions";

const PerfilColaborador = (props) => {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const [isPageFirstLoad, setIsPageFirstLoad] = useState(false);


    const {
        loading,
        saveLoading,
        formacionColaborador,
        formacionColaboradorError
    } = useSelector((store) => store.formacionColaborador)


    const _getFormacionColaborador = () => {
        dispatch(getFormacionColaborador({
            empleado: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }));

    }

    const _createFormacionColaborador = () => {
        dispatch(saveFormacionColaborador({
            empleado: props.match.params.codigoTitular,
            matriz_id: props.match.params.idMatriz
        }))
    }

    useEffect(() => {
        dispatch(clearFormacionColaborador())
        setIsPageFirstLoad(true);

    }, [])

    useEffect(() => {
        if (formacionColaborador == null && !formacionColaboradorError){
            _getFormacionColaborador();
        }
    }, [formacionColaborador]);

    useEffect(() => {
        if (!loading && formacionColaborador && isPageFirstLoad) {
            const isEmptyArrays = Object.values(formacionColaborador).every(
                (arr) => Array.isArray(arr) && arr.length === 0
            );

            if (isEmptyArrays) {
                _createFormacionColaborador();
            }
        }
    }, [loading, formacionColaborador, isPageFirstLoad]);

    const handleSubmit = (item) => {
        let _req = {
            formacion_marca: !item.formacion_marcada
        }
        dispatch(editFormacionColaborador(_req, item.id, {empleado: props.match.params.codigoTitular, matriz_id: props.match.params.idMatriz}))
    }
    const checkedFormationCounter = formacionColaborador?.formacion_evaluada_persona.reduce((acc, cur) => {
        if (cur.formacion_marcada === true) {
            return acc + 1;
        }
        return acc;
    }, 0);

    const checkedExperienceCounter = formacionColaborador?.experiencia_evaluada_persona.reduce((acc, cur) => {
        if (cur.experiencia_marcada === true) {
            return acc + 1;
        }
        return acc;
    }, 0);
    const totalPercentage = (checkedExperienceCounter + checkedFormationCounter) / (formacionColaborador?.experiencia_evaluada_persona.length + formacionColaborador?.formacion_evaluada_persona.length) * 100
    const onShowSidebar = () => setShow(show ? false : true);


    return (
        <>
            {loading || saveLoading ? (
                <div className='d-flex justify-content-center'>
                    <Spinner
                        animation='border'
                        role='status'
                        className='d-flex justify-content-center'
                    />
                </div>
            ) : (
                <div className="mt-5">
                    <Row>
                        <Col sm={12} md={7} lg={7}>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#fff", border: "0px", width: "40%" }}></th>
                                        <th style={{ backgroundColor: "#fff", border: "0px", width: "60%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formacionColaborador?.formacion_persona.length > 0 && formacionColaborador ? (
                                        formacionColaborador.formacion_persona.map((item, index) => (
                                            <tr key={index}>
                                                {index == 0 && (<td className="bg-dark" style={{color: "#fff" }} rowSpan={formacionColaborador?.formacion_persona.length}>Formación del Colaborador</td>)}
                                                <td>{item.nombre_formacion}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="bg-dark" style={{color: "#fff" }}>Formación del Colaborador</td>
                                            <td>
                                                <Alert variant="info">
                                                    No hay información para mostrar.
                                                </Alert>
                                            </td>
                                        </tr>

                                    )
                                    }

                                    {formacionColaborador?.experiencia_persona.length > 0 && formacionColaborador ? (
                                        formacionColaborador.experiencia_persona.map((item, index) => (
                                            <tr key={index}>
                                                {index == 0 && (<td className="bg-dark" style={{color: "#fff" }} rowSpan={formacionColaborador?.experiencia_persona.length}>Experiencia Laboral</td>)}
                                                <td>{item.nombre_formacion}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="bg-dark" style={{color: "#fff" }}>Experiencia Laboral</td>
                                            <td>
                                                <Alert variant="info">
                                                    No hay información para mostrar.
                                                </Alert>
                                            </td>
                                        </tr>
                                    )}



                                </tbody>
                            </Table>

                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr>
                                        <th style={{ backgroundColor: "#fff", border: "0px", width: "40%" }}></th>
                                        <th style={{ backgroundColor: "#fff", border: "0px", width: "60%" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formacionColaborador?.formacion_persona_requerida.length > 0 && formacionColaborador ? (
                                        formacionColaborador.formacion_persona_requerida.map((item, index) => (
                                            <tr key={index}>
                                                {index == 0 && (<td className="bg-dark" style={{color: "#fff" }} rowSpan={formacionColaborador?.formacion_persona_requerida.length}>Formación Requerida</td>)}
                                                <td>{item.nombre_formacion_requerida}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="bg-dark" style={{color: "#fff" }}>Formación Requerida</td>
                                            <td>
                                                <Alert variant="info">
                                                    No hay información para mostrar.
                                                </Alert>
                                            </td>
                                        </tr>

                                    )
                                    }

                                    {formacionColaborador?.experiencia_persona_requerida.length > 0 && formacionColaborador ? (
                                        formacionColaborador.experiencia_persona_requerida.map((item, index) => (
                                            <tr key={index}>
                                                {index == 0 && (<td className="bg-dark" style={{color: "#fff" }} rowSpan={formacionColaborador?.experiencia_persona_requerida.length}>Experiencia Laboral Requerida</td>)}
                                                <td>{item.nombre_formacion_requerida}</td>

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="bg-dark" style={{color: "#fff" }}>Experiencia Laboral Requerida</td>
                                            <td>
                                                <Alert variant="info">
                                                    No hay información para mostrar.
                                                </Alert>
                                            </td>
                                        </tr>
                                    )}



                                </tbody>
                            </Table>


                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            <Table striped bordered hover responsive className="mt-4">
                                <thead>
                                    <tr>
                                        <th style={{ width: "80%" }}>Formación</th>
                                        <th className="bg-success p-3 text-white" style={{ backgroundColor: "#fff", border: "0px", width: "20%", textAlign: "center" }}>{totalPercentage || 0}%</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {formacionColaborador?.formacion_evaluada_persona.length > 0 && formacionColaborador && (
                                        formacionColaborador.formacion_evaluada_persona.map((item, index) => (
                                            <tr key={index}>
                                                <td className="bg-dark" style={{color: "#fff" }}>{item.nombre_formacion_evaluada}</td>
                                                <td className="text-center">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={item.formacion_marcada}
                                                        onChange={() => handleSubmit(item)}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    )}

                                    {formacionColaborador?.experiencia_evaluada_persona.length > 0 && formacionColaborador && (
                                        formacionColaborador.experiencia_evaluada_persona.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ backgroundColor: "#6c757d", color: "#fff" }}>{item.nombre_formacion_evaluada}</td>
                                                <td className="text-center">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={item.formacion_marcada}
                                                        onChange={() => handleSubmit(item)}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    )}


                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </div>
            )}

        </>


    );
};

export default PerfilColaborador;
